import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getReservationsByAnnouncement } from "../../services/reservationService";

export const fetchReservations = createAsyncThunk(
  "reservation/fetchReservations",
  async ({ announcementId, page = 1, limit = 10 }, thunkAPI) => {
    try {
      const data = await getReservationsByAnnouncement(announcementId, page, limit);
      console.log("Fetched reservations data:", data);
      return data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  reservations: [],
  total: 0,
  totalPages: 1,
  currentPage: 1,
  loading: false,
  error: null,
};

const reservationSlice = createSlice({
  name: "reservation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReservations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReservations.fulfilled, (state, action) => {
        state.loading = false;
        state.reservations = action.payload.items || [];
        state.total = action.payload.totalItems || 0;
        state.currentPage = action.payload.currentPage || 1;
        state.totalPages = action.payload.totalPages || 1;
      })
      .addCase(fetchReservations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default reservationSlice.reducer;
